import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

// Obtener el token de Mapbox del elemento input oculto
const accessToken = document.querySelector("#tokenmapboxevents")?.value;
if (accessToken) {
    mapboxgl.accessToken = accessToken;
}

document.addEventListener('DOMContentLoaded', function () {
    console.log('map-events-view.js loaded (v3)');
    
    const externalModule = document.getElementById('externalActivitiesModuleV3');
    const whatToSeeModule = document.getElementById('whatToSeeModuleV3');
    
    // Si es EXTERNAL ACTIVITIES, manejar TODO (mapa + filtros)
    if (externalModule) {
        console.log('Inicializando external-activities-v3');
        handleMapAndFilters(externalModule);
    }
    
    // Si es WHAT TO SEE, SOLO manejar mapa (app-public.js maneja losltros)
    if (whatToSeeModule) {
        console.log('Inicializando what-to-see-v3 (solo mapa)');
        handleMapOnly(whatToSeeModule);
    }
});

// ========== EXTERNAL ACTIVITIES: MAPA + FILTROS ==========
function handleMapAndFilters(module) {
    const viewToggleBtn = module.querySelector('#viewToggleBtn');
    const listView = module.querySelector('#listView');
    const mapView = module.querySelector('#mapView');
    const eventsMapContainer = module.querySelector('#events-map');
    const toggleFiltersBtn = module.querySelector('#toggleFiltersBtn');
    const filtersPanel = module.querySelector('#filtersPanel');
    const applyFiltersBtn = module.querySelector('.js-applyFilters');
    const clearFiltersBtn = module.querySelector('.js-clearFilters');
    const pageButtons = module.querySelectorAll('.js-pageButton');

    let mapInstance = null;
    let currentView = sessionStorage.getItem('eventsView') || 'list';

    // ===== MAPA =====
    function switchView(view) {
        currentView = view === 'map' ? 'map' : 'list';

        if (currentView === 'list') {
            listView.style.display = 'flex';
            mapView.style.display = 'none';
        } else {
            listView.style.display = 'none';
            mapView.style.display = 'block';

            if (!mapInstance && eventsMapContainer) {
                initializeMap();
            } else if (mapInstance) {
                mapInstance.resize();
            }
        }

        sessionStorage.setItem('eventsView', currentView);
        updateToggleButton();
    }

    function updateToggleButton() {
        if (!viewToggleBtn) return;
        const labelMap = viewToggleBtn.dataset.labelMap || 'Ver en mapa';
        const labelList = viewToggleBtn.dataset.labelList || 'Ver en listado';
        
        if (currentView === 'list') {
            viewToggleBtn.textContent = labelMap;
            viewToggleBtn.classList.add('mostrarMapa');
            viewToggleBtn.classList.remove('mostrarListado');
        } else {
            viewToggleBtn.textContent = labelList;
            viewToggleBtn.classList.add('mostrarListado');
            viewToggleBtn.classList.remove('mostrarMapa');
        }
    }

    function initializeMap() {
        if (!eventsMapContainer || !accessToken) return;

        const eventsData = [];
        
        // Buscar SOLO dentro del módulo external
        module.querySelectorAll('.js-eventData.d-none').forEach(el => {
            const lat = parseFloat(el.dataset.lat);
            const lng = parseFloat(el.dataset.lng);
            console.log(`Procesando evento: ${el.dataset.name}, lat: ${lat}, lng: ${lng}`);

            if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                eventsData.push({
                    lat: lat,
                    lng: lng,
                    name: el.dataset.name || 'Sin nombre',
                    slug: el.dataset.slug || ''
                });
            }
        });

        console.log('Total eventos para el mapa (external):', eventsData.length);

        if (eventsData.length === 0) {
            eventsMapContainer.innerHTML = '<p class="text-center p-5">No hay eventos con ubicación disponible</p>';
            return;
        }

        mapInstance = new mapboxgl.Map({
            container: 'events-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [0, 0],
            zoom: 1
        });

        mapInstance.on('load', function () {
            const bounds = new mapboxgl.LngLatBounds();
            const origin = window.location.origin || '';
            const secureOrigin = origin.startsWith('https://')
                ? origin
                : origin.startsWith('http://')
                    ? origin.replace('http://', 'https://')
                    : `https://${origin.replace(/^\/+/, '')}`;

            eventsData.forEach(event => {
                bounds.extend([event.lng, event.lat]);

                const popup = new mapboxgl.Popup({ offset: 35 })
                    .setHTML(`<strong><a href="${secureOrigin}/en/actividades/${event.slug}" target="_blank">${event.name}</a></strong>`);

                new mapboxgl.Marker()
                    .setLngLat([event.lng, event.lat])
                    .setPopup(popup)
                    .addTo(mapInstance);
            });

            if (eventsData.length === 1) {
                mapInstance.setCenter([eventsData[0].lng, eventsData[0].lat]);
                mapInstance.setZoom(12);
            } else if (bounds && bounds.isEmpty() === false) {
                mapInstance.fitBounds(bounds, {
                    padding: 50,
                    maxZoom: 15,
                    duration: 1000
                });
            }
        });
    }

    if (viewToggleBtn) {
        if (!viewToggleBtn.dataset.labelMap) viewToggleBtn.dataset.labelMap = 'Ver en mapa';
        if (!viewToggleBtn.dataset.labelList) viewToggleBtn.dataset.labelList = 'Ver en listado';

        viewToggleBtn.addEventListener('click', function () {
            const nextView = currentView === 'list' ? 'map' : 'list';
            switchView(nextView);
        });
    }

    switchView(currentView);

    // ===== FILTROS =====
    function getStoredFilters() {
        const stored = sessionStorage.getItem('eventFilters');
        return stored ? JSON.parse(stored) : null;
    }

    function storeFilters(filters) {
        sessionStorage.setItem('eventFilters', JSON.stringify(filters));
    }

    function submitFiltersForm(page = 1) {
        const storedFilters = getStoredFilters();
        const filterSlug = module.querySelector('#filterSlug')?.value || '';

        const form = document.createElement('form');
        form.method = 'POST';
        
        // Mantener la URL actual con el slug intacto
        let pathname = window.location.pathname;
        form.action = pathname || window.location.pathname;

        const csrfElement = document.querySelector('meta[name="csrf-token"]');
        if (!csrfElement) {
            console.error('CSRF token no encontrado');
            return;
        }
        
        const csrfToken = csrfElement.getAttribute('content');
        const csrfInput = document.createElement('input');
        csrfInput.type = 'hidden';
        csrfInput.name = '_token';
        csrfInput.value = csrfToken;
        form.appendChild(csrfInput);

        if (storedFilters) {
            ['filter', 'interest', 'accompaniment'].forEach(type => {
                if (storedFilters[type] && storedFilters[type].length > 0) {
                    storedFilters[type].forEach(value => {
                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = type + '[]';
                        input.value = value;
                        form.appendChild(input);
                    });
                }
            });
        }

        const pageInput = document.createElement('input');
        pageInput.type = 'hidden';
        pageInput.name = 'page';
        pageInput.value = page;
        form.appendChild(pageInput);

        document.body.appendChild(form);
        form.submit();
    }

    function restoreFilters() {
        const storedFilters = getStoredFilters();

        if (storedFilters) {
            module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
                const type = checkbox.dataset.type;
                const value = checkbox.value;

                if (storedFilters[type] && storedFilters[type].includes(value)) {
                    checkbox.checked = true;
                } else {
                    checkbox.checked = false;
                }
            });

            if (filtersPanel) {
                filtersPanel.style.display = 'block';
                if (toggleFiltersBtn) {
                    toggleFiltersBtn.classList.add('active');
                }
            }
        }
    }

    restoreFilters();

    if (toggleFiltersBtn && filtersPanel) {
        toggleFiltersBtn.addEventListener('click', function () {
            if (filtersPanel.style.display === 'none' || filtersPanel.style.display === '') {
                filtersPanel.style.display = 'block';
                toggleFiltersBtn.classList.add('active');
            } else {
                filtersPanel.style.display = 'none';
                toggleFiltersBtn.classList.remove('active');
            }
        });
    }

    if (applyFiltersBtn) {
        applyFiltersBtn.addEventListener('click', function (e) {
            e.preventDefault();
            
            const selectedFilters = {
                filter: [],
                interest: [],
                accompaniment: []
            };

            module.querySelectorAll('.js-filterCheckbox:checked').forEach(checkbox => {
                const type = checkbox.dataset.type;
                const value = checkbox.value;

                if (selectedFilters[type]) {
                    selectedFilters[type].push(value);
                }
            });

            storeFilters(selectedFilters);
            submitFiltersForm(1);
        });
    }

    if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', function (e) {
            e.preventDefault();
            
            module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
                checkbox.checked = false;
            });

            sessionStorage.removeItem('eventFilters');

            if (filtersPanel) {
                filtersPanel.style.display = 'none';
            }
            if (toggleFiltersBtn) {
                toggleFiltersBtn.classList.remove('active');
            }

            window.location.href = window.location.pathname;
        });
    }

    if (pageButtons && pageButtons.length > 0) {
        pageButtons.forEach(button => {
            button.addEventListener('click', function (e) {
                e.preventDefault();
                const page = this.dataset.page;
                submitFiltersForm(page);
            });
        });
    }

    // Auto-aplicar filtros al cambiar checkboxes
    module.querySelectorAll('.js-filterCheckbox').forEach(checkbox => {
        checkbox.addEventListener('change', function () {
            if (applyFiltersBtn) {
                applyFiltersBtn.click();
            }
        });
    });
}

// ========== WHAT TO SEE: SOLO MAPA (filtros gestionados por app-public.js) ==========
function handleMapOnly(module) {
    const viewToggleBtn = module.querySelector('#viewToggleBtn');
    const listView = module.querySelector('#listView');
    const mapView = module.querySelector('#mapView');
    const eventsMapContainer = module.querySelector('#events-map');

    let mapInstance = null;
    let currentView = sessionStorage.getItem('eventsView') || 'list';

    function updateToggleButton() {
        if (!viewToggleBtn) return;
        const labelMap = viewToggleBtn.dataset.labelMap || 'Ver en mapa';
        const labelList = viewToggleBtn.dataset.labelList || 'Ver en listado';
        
        if (currentView === 'list') {
            viewToggleBtn.textContent = labelMap;
            viewToggleBtn.classList.add('mostrarMapa');
            viewToggleBtn.classList.remove('mostrarListado');
        } else {
            viewToggleBtn.textContent = labelList;
            viewToggleBtn.classList.add('mostrarListado');
            viewToggleBtn.classList.remove('mostrarMapa');
        }
    }

    function switchView(view) {
        currentView = view === 'map' ? 'map' : 'list';

        if (currentView === 'list') {
            listView.style.display = 'flex';
            mapView.style.display = 'none';
        } else {
            listView.style.display = 'none';
            mapView.style.display = 'block';

            if (!mapInstance && eventsMapContainer) {
                initializeMap();
            } else if (mapInstance) {
                mapInstance.resize();
            }
        }

        sessionStorage.setItem('eventsView', currentView);
        updateToggleButton();
    }

    function initializeMap() {
        if (!eventsMapContainer || !accessToken) return;

        const eventsData = [];
        
        // Buscar SOLO dentro del módulo what-to-see
        module.querySelectorAll('.js-eventData.d-none').forEach(el => {
            const lat = parseFloat(el.dataset.lat);
            const lng = parseFloat(el.dataset.lng);

            if (!isNaN(lat) && !isNaN(lng) && isFinite(lat) && isFinite(lng)) {
                eventsData.push({
                    lat: lat,
                    lng: lng,
                    name: el.dataset.name || 'Sin nombre',
                    slug: el.dataset.slug || ''
                });
            }
        });

        console.log('Total eventos para el mapa (what-to-see):', eventsData.length);

        if (eventsData.length === 0) {
            eventsMapContainer.innerHTML = '<p class="text-center p-5">No hay eventos con ubicación disponible</p>';
            return;
        }

        mapInstance = new mapboxgl.Map({
            container: 'events-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: [0, 0],
            zoom: 1
        });

        mapInstance.on('load', function () {
            const bounds = new mapboxgl.LngLatBounds();
            const origin = window.location.origin || '';
            const secureOrigin = origin.startsWith('https://')
                ? origin
                : origin.startsWith('http://')
                    ? origin.replace('http://', 'https://')
                    : `https://${origin.replace(/^\/+/, '')}`;

            eventsData.forEach(event => {
                bounds.extend([event.lng, event.lat]);

                const popup = new mapboxgl.Popup({ offset: 35 })
                    .setHTML(`<strong><a href="${secureOrigin}/en/actividades/${event.slug}" target="_blank">${event.name}</a></strong>`);

                new mapboxgl.Marker()
                    .setLngLat([event.lng, event.lat])
                    .setPopup(popup)
                    .addTo(mapInstance);
            });

            if (eventsData.length === 1) {
                mapInstance.setCenter([eventsData[0].lng, eventsData[0].lat]);
                mapInstance.setZoom(12);
            } else if (bounds && bounds.isEmpty() === false) {
                mapInstance.fitBounds(bounds, {
                    padding: 50,
                    maxZoom: 15,
                    duration: 1000
                });
            }
        });
    }

    if (viewToggleBtn) {
        if (!viewToggleBtn.dataset.labelMap) viewToggleBtn.dataset.labelMap = 'Ver en mapa';
        if (!viewToggleBtn.dataset.labelList) viewToggleBtn.dataset.labelList = 'Ver en listado';

        viewToggleBtn.addEventListener('click', function () {
            const nextView = currentView === 'list' ? 'map' : 'list';
            switchView(nextView);
        });
    }

    switchView(currentView);
}
